import { AttachmentCategory } from 'shared/enums';

export function uploadUrl(category: AttachmentCategory) {
    return `api/attachment/?category=${encodeURIComponent(category)}`
}